package apps

import apps.App.Kindergarten


val Kindergarten.Companion.colors
    get() = listOf(
        0x3AAA35,
        0x312783,
        0xA77077,
        0xBE1622,
        0xF9B233,
        0xCB454E,
        0x956DBC,
        0xDD9A72,
        0xA3195B,
        0xC48584,
        0x877AA9,
        0xE94E1B,
        0xBB426A,
        0xED7149,
        0x261B95,
        0x926D7A,
        0xF5D48A,
        0x662483,
        0x428BBB,
        0x7C4AC9,
        0x7B6A58,
        0x2DB383,
        0x951B81,
        0x009FE3,
        0xEEB83C,
        0xC03E27,
        0x6EDA69,
        0x736F9A,
        0x84B356,
    )